import type { IRequest } from '../../common/interfaces/IRequest';
import { ServiceCode } from '../../common/enums/ServiceCode';

export function shouldShowDrivingLicenseSleepCard(processes?: IRequest[]) {
    return !!processes?.find(
        (request: IRequest) =>
            request.service.code === ServiceCode.OSASC2 && request.customControlData?.isDrivingLicenseDiscussed
    );
}
